<template>
  <nav>
    <div v-if="!$isMobile">
      {{ $content.nav }}
    </div>
    <ul>
      <li
        v-for="collection in $collections"
        :key="collection.id"
      >
        <HomeCollectionItem
          :collection="collection"
          :has-notice="true"
        />
      </li>
    </ul>
  </nav>
</template>
<script>
import HomeCollectionItem from './HomeCollectionItem.vue';

export default {
  name: 'HomeCollectionList',
  components: {
    HomeCollectionItem,
  },
};
</script>
<style lang="stylus" scoped>
nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;

  div {
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
  }

  +mobile(){
    padding: 12px 0;
  }

  ul {
    display: flex;
    gap: 10px;

    +mobile() {
      width: 100%;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
